import * as ɵngcc0 from '@angular/core';
export * from '@colibrium/abp-base';
import { AbpNavMenuConstant, AbpNavMenuModule } from '@colibrium/abp-nav-menu';
export { AbpMenuItemModel, AbpNavMenuComponent, AbpNavMenuConstant, AbpNavMenuModel, AbpNavMenuModule } from '@colibrium/abp-nav-menu';
import { AbpPopupModule } from '@colibrium/abp-popup';
export { AbpContentPopupComponent, AbpMessagePopupComponent, AbpMessagePopupModel, AbpPopupModule } from '@colibrium/abp-popup';
export * from '@colibrium/abp-pipe';
import { AbpCalendarConstant, AbpCalendarModule } from '@colibrium/abp-calendar';
export * from '@colibrium/abp-calendar';
import { AbpDatepickerConstant, AbpTextboxConstant, AbpValidationDisplayConstant, AbpLabelConstant, AbpFormControlModule } from '@colibrium/abp-form-control';
export * from '@colibrium/abp-form-control';
import { AbpDynamicFormModule } from '@colibrium/abp-dynamic-form';
export * from '@colibrium/abp-dynamic-form';
import { __decorate } from 'tslib';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//#region angular imports
var AbpSuiteModule_1;
//#endregion pipes/filters
let AbpSuiteModule = AbpSuiteModule_1 = class AbpSuiteModule {
    constructor() {
    }
    static forRoot(config) {
        return {
            ngModule: AbpSuiteModule_1,
            providers: [
                { provide: AbpCalendarConstant.calendarConfigInjectKey, useValue: config.calendarConfig },
                { provide: AbpNavMenuConstant.navConfigInjectKey, useValue: config.navConfig },
                { provide: AbpDatepickerConstant.dateConfigInjectKey, useValue: config.formControlConfig.dateConfig },
                { provide: AbpTextboxConstant.textboxConfigInjectKey, useValue: config.formControlConfig.textConfig },
                { provide: AbpValidationDisplayConstant.validationDisplayConfigInjectKey, useValue: config.formControlConfig.validationConfig },
                { provide: AbpLabelConstant.labelConfigInjectKey, useValue: config.formControlConfig.labelConfig }
            ]
        };
    }
};
AbpSuiteModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AbpSuiteModule });
AbpSuiteModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AbpSuiteModule_Factory(t) { return new (t || AbpSuiteModule)(); }, imports: [[
            CommonModule,
            AbpCalendarModule,
            AbpNavMenuModule,
            AbpPopupModule,
            //AbpPipeModule,
            AbpFormControlModule,
            AbpDynamicFormModule
        ], AbpCalendarModule,
        AbpNavMenuModule,
        AbpPopupModule,
        //AbpPipeModule,
        AbpFormControlModule,
        AbpDynamicFormModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AbpSuiteModule, { imports: function () { return [CommonModule,
        AbpCalendarModule,
        AbpNavMenuModule,
        AbpPopupModule,
        //AbpPipeModule,
        AbpFormControlModule,
        AbpDynamicFormModule]; }, exports: function () { return [AbpCalendarModule,
        AbpNavMenuModule,
        AbpPopupModule,
        //AbpPipeModule,
        AbpFormControlModule,
        AbpDynamicFormModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpSuiteModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AbpCalendarModule,
                    AbpNavMenuModule,
                    AbpPopupModule,
                    //AbpPipeModule,
                    AbpFormControlModule,
                    AbpDynamicFormModule
                ],
                declarations: [],
                entryComponents: [],
                exports: [
                    AbpCalendarModule,
                    AbpNavMenuModule,
                    AbpPopupModule,
                    //AbpPipeModule,
                    AbpFormControlModule,
                    AbpDynamicFormModule
                ]
            }]
    }], function () { return []; }, null); })();

/*
 * Public API Surface of abp-suite
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbpSuiteModule };

//# sourceMappingURL=colibrium-abp-suite.js.map